import React from "react";
import styled from "styled-components";

export default styled.div`
    color: grey;
    font-weight: 700;
    margin-bottom: 15px;
`;